<script lang="ts">
  import { Button, Reactions } from "@opera-gx/components";
  export let reactions:
    | {
        id: number;
        name: string;
        emoticon: string;
        count: number;
        liked: boolean;
      }[]
    | undefined;
  export let minimode: number;
  export let postKey: string;
  export let button: {
    url: string;
    label: string;
  } | null;
  export let layout: "reactionsRight" | "buttonCenter" | "regular" = "regular";
  let buttonCenter = layout === "buttonCenter";
  let reactionsRight = layout === "reactionsRight";
  let regular = layout === "regular";

  const checkReactionStorage = () => {
    let savedReaction = JSON.parse(localStorage.getItem("store-reactions-list"));

    if (savedReaction && savedReaction[postKey]) {
      let foundEmoji = reactions.find((obj) => obj.id === savedReaction[postKey]?.id);

      if (foundEmoji) {
        foundEmoji.liked = true;
        foundEmoji.count += 1;
      }
    }
  };

  const saveClickedIcon = (id: number) => {
    let existingData = localStorage.getItem("store-reactions-list");

    let data = existingData ? JSON.parse(existingData) : {};

    data[postKey] = {
      id: id,
    };

    const maxFields = 21;
    const keys = Object.keys(data);

    if (keys.length > maxFields) {
      const oldestKeys = keys.slice(0, keys.length - maxFields);

      oldestKeys.forEach((key) => {
        delete data[key];
      });
    }

    localStorage.setItem("store-reactions-list", JSON.stringify(data));
  };

  checkReactionStorage();
</script>

<style lang="scss">
  .reactions-wrapper {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0;
    align-items: end;
    width: 100%;
  }

  .reactions-container {
    grid-column: 1;

    &.regular {
      position: relative;
      height: 100px;

      .reaction-absolute {
        position: absolute;
        bottom: 0;
        width: 100%;
        min-width: 200px;
      }
    }

    &.reactionsRight {
      position: relative;
      height: 100px;

      @media (width >= 600px), (orientation: landscape) {
        grid-column: 3;
      }

      .reaction-absolute {
        position: absolute;
        bottom: 0;
        width: 100%;
      }
    }
  }

  .button-container {
    grid-column: 3;

    &.buttonCenter {
      grid-column: 2;
    }
  }

  .button {
    position: relative;
    display: block;
    padding: 0 0 20px;
    min-width: 132px;
    max-width: 160px;
    margin-right: 20px;
    margin-left: auto;

    @media (width <= 480px) {
      min-width: auto;
    }

    &.buttonCenter {
      margin: 0 auto;
    }
  }
</style>

<div class="reactions-wrapper">
  <div class="reactions-container" class:reactionsRight class:regular>
    <div class="reaction-absolute">
      <Reactions
        {reactions}
        {minimode}
        on:clickedReactionId={(event) => saveClickedIcon(event.detail)} />
    </div>
  </div>
  {#if button?.url}
    <div class="button-container" class:buttonCenter>
      <a href={button.url} class="button" class:buttonCenter target="_blank">
        <Button primary variant={"mobile"} disabled={false}
          >{button?.label ?? "Watch on Youtube"}</Button>
      </a>
    </div>
  {/if}
</div>
